import { VideoSideContents } from '@belong/ui';

export const VideoSectionSlice = VideoSideContents;
